module.exports = __webpack_public_path__ + "img/accessory_shirt_11.6e111e0a.svg";